var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBBoxesStacked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconB-boxes-stacked",
    x: 0,
    y: 0,
    width: 23.998,
    height: 23.998,
    style: {
      fill: "none"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.999,14.999l0,6c0,1.104 -0.896,2 -2,2l-6,0c-1.104,0 -2,-0.896 -2,-2l0,-6c0,-1.104 0.896,-2 2,-2l6,0c1.104,0 2,0.896 2,2Zm-6,0l-2,0l0,6l6,0l0,-6l-2,0l0,1c0,0.552 -0.448,1 -1,1c-0.552,0 -1,-0.448 -1,-1l0,-1Zm18,0l0,6c0,1.104 -0.896,2 -2,2l-6,0c-1.104,0 -2,-0.896 -2,-2l0,-6c0,-1.104 0.896,-2 2,-2l6,0c1.104,0 2,0.896 2,2Zm-6,0l-2,0l0,6l6,0l0,-6l-2,0l0,1c0,0.552 -0.448,1 -1,1c-0.552,0 -1,-0.448 -1,-1l0,-1Zm0,-12l0,6c0,1.104 -0.896,2 -2,2l-6,0c-1.104,0 -2,-0.896 -2,-2l0,-6c0,-1.104 0.896,-2 2,-2l6,0c1.104,0 2,0.896 2,2Zm-6,0l-2,0l0,6l6,0l0,-6l-2,0l0,1c0,0.552 -0.448,1 -1,1c-0.552,0 -1,-0.448 -1,-1l0,-1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBBoxesStacked);
export default __webpack_public_path__ + "static/media/iconB-boxes-stacked.ff6aa636abfc755633c6525580aad439.svg";
export { ForwardRef as ReactComponent };